import { FolderModel, FolderType } from '../../../../../gamma-api';

export const MAIN_CLASS_NAME = 'folder-modal';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const FORM_ITEM_CLASS_NAME = `${CONTENT_CLASS_NAME}__form-item`;

export const EMPTY_FOLDER: FolderModel = {
  folder_id: '',
  external_id: '',
  type: FolderType.Custom,
  name: '',
  settings: {},
  projects: [],
  chat_agents: [],
  api_agents: [],
  toolkits: [],
};
